import React, { useState } from 'react';
import { useCart } from '../context/CartContext';
import CartItem from '../components/Cart/CartItem';
import TipSelector from '../components/Cart/TipSelector';
import './CartPage.css';

const CartPage = ({ setCurrentPage, onCheckout }) => {
  const { cartItems, updateQuantity, removeItem, clearCart, selectedStore } = useCart();
  const [selectedTip, setSelectedTip] = useState(0.15);

  const calculateSubtotal = () => {
    return cartItems.reduce((total, item) => total + item.total, 0);
  };

  const calculateTip = () => {
    return calculateSubtotal() * selectedTip;
  };

  const calculateTotal = () => {
    return calculateSubtotal() + calculateTip();
  };

  const handleCheckout = () => {
    if (onCheckout) {
      onCheckout();
    } else {
      setCurrentPage('checkout');
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page empty">
        <h2>Tu carrito está vacío</h2>
        <button 
          className="browse-menu-btn"
          onClick={() => setCurrentPage('order')}
        >
          Browse Menu
        </button>
      </div>
    );
  }

  return (
    <div className="cart-page">
      <h2>Revisar orden</h2>
      
      <div className="cart-items">
        {cartItems.map(item => (
          <CartItem 
            key={item.cartId} 
            item={item} 
            onUpdateQuantity={updateQuantity}
            onRemove={removeItem}
          />
        ))}
      </div>
      
      <button 
        className="add-more-btn"
        onClick={() => setCurrentPage('menu')}
      >
        + Agregar más 
      </button>
      
      <TipSelector 
        selectedTip={selectedTip}
        onTipChange={setSelectedTip}
        tipAmount={calculateTip()}
      />
      
      <div className="order-summary">
        <h3>Resumen del pedido</h3>
        <div className="summary-line">
          <span>Sub Total</span>
          <span>${calculateSubtotal().toFixed(2)}</span>
        </div>
        <div className="summary-line">
          <span>Tip ({Math.round(selectedTip * 100)}%)</span>
          <span>${calculateTip().toFixed(2)}</span>
        </div>
        <div className="promo-code">
          <span>+ agregar código promoción</span>
        </div>
        <div className="summary-total">
          <span>TOTAL</span>
          <span>${calculateTotal().toFixed(2)}</span>
        </div>
      </div>
      
      {selectedStore && (
        <div className="pickup-info">
          <h4>Pickup at</h4>
          <p>{selectedStore.name}</p>
          <p>{selectedStore.address}</p>
          <p className="ready-time">Listo 10 - 15 min</p>
        </div>
      )}
      
      <button className="checkout-btn" onClick={handleCheckout}>
        Proceed to Checkout
      </button>
    </div>
  );
};

export default CartPage;